import React, { useContext } from 'react';
import { ritzDataContext, selectProjectById } from '@moderepo/mode-data-state-ritz';
import { NotificationContainer } from '@moderepo/mode-app-components';
import { useParams } from 'react-router-dom';
import { useRitzTranslation } from '../../utils/customHooks';

/**
 * This is the wrapper for the NotificationComponent. The notification component is a generic component that does not do anything other
 * than display the message. This container will take care of providing the NotificationComponent all the data necessary needed to render
 * the notification base on the UI state.
 */
export const NotificationProvider: React.FC = () => {
    const params = useParams();
    const projectId = params.projectId ? Number(params.projectId) : undefined;
    const { state:dataState } = useContext(ritzDataContext);
    const project = projectId ? selectProjectById(dataState, projectId) : undefined;
    const { trans } = useRitzTranslation(project);

    return (
        <NotificationContainer
            translate={trans}
        />
    );
};
